import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContentfulService } from '../contentful.service';
import { SharedDataService } from "../shared-data.service";
import { Entry, Asset, EntryCollection } from 'contentful';

@Component({
  selector: 'app-program-detail',
  templateUrl: './program-detail.component.html',
  styleUrls: ['./program-detail.component.css']
})
export class ProgramDetailComponent implements OnInit {

  // define class properties
  public modules: Entry<any>[] = [];
  public selectedProgram: Entry<any>;
  public selectedProgramAsset: EntryCollection<any>;
  public modulesAsset: EntryCollection<any>;
  public selectedProgramId: string;
  public selectedModuleId: string;

  constructor(private router: Router, private contentfulService: ContentfulService, private sharedData: SharedDataService) { }

  ngOnInit() {
    this.selectedProgramId = sessionStorage.getItem("ProgramId");
    //this.sharedData.currentMessage.subscribe(message => this.selectedProgramId = message)
    //this.sharedData.currentModule.subscribe(message => this.selectedModuleId = message)
    //this.contentfulService.getPrograms().then(x => this.programs = x);
    this.contentfulService.getProgram(this.selectedProgramId).then(x => this.selectedProgram = x);
    this.contentfulService.getModulesByProgram(this.selectedProgramId).then(x => this.modules = x);
    //this.contentfulService.getModulesAssetsByProgram(this.selectedProgramId).then(x => this.modulesAsset = x);
  }
  
  Redirect(moduleId, moduleName) {
    this.sharedData.changeModuleId(moduleId);
    sessionStorage.setItem("moduleId", moduleId);
    this.router.navigate(['/module-list' + '/' + moduleName]);
  }

  ToActivityDetail(module: Number) {
    //alert(module.toString());
    this.router.navigate(['/activity-detail']);
  }

  ToModuleForum(module: Number) {
    //alert(module.toString());
    this.router.navigate(['/module-forum']);
  }
}
